import { render } from "./PostForm.vue?vue&type=template&id=13277cef"
import script from "./PostForm.vue?vue&type=script&lang=js"
export * from "./PostForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/PostForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13277cef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13277cef', __exports__)) {
    api.reload('13277cef', __exports__)
  }
  
  module.hot.accept("./PostForm.vue?vue&type=template&id=13277cef", () => {
    api.rerender('13277cef', render)
  })

}


export default __exports__